<template></template>

<script>
export default {
  data() {
    return {};
  },
  created: function() {},
  watch: {},

  mounted: function() {},
  methods: {
    changeSeite(i) {
      this.$_modusChangeEvent("modus/changeModusSeite", {
        modus: this.modus,
        seiteIdx: i
      });
    },
    b_changeSeite(i, type) {
      this.$_modusChangeEvent("modus/b_changeSeite", {
        modus: this.modus,
        seiteIdx: i
      });
    }
  },
  computed: {
    modus() {
      return this.$store.getters["modus/getModusByIdKey"]({
        modusId: this.modusId,
        viewKey: this.viewKey
      });
    },
    merz() {
      return this.$store.getters["modus/getModusMerz"](this.modus);
    },
    seiteIdx() {
      return this.$store.getters["modus/getModusSeiteIdx"](this.modus);
    },
    seite() {
      if (this.seiten && this.seiteIdx != undefined) {
        return this.seiten[this.seiteIdx];
      }
    },
    seiten() {
      return this.$store.getters["modus/getModusSeiten"](this.modus);
    },
    modusOption() {
      return this.modus.option;
    },

    //vergleich b
    b_merz() {
      return this.$store.getters["modus/b_merz"](this.modus);
    },
    b_seiteIdx() {
      return this.$store.getters["modus/b_seiteIdx"](this.modus);
    },
    b_seiten() {
      return this.$store.getters["modus/b_seiten"](this.modus);
    },
    b_modusOption() {
      return this.modus.option.b;
    }
  }
};
</script>


// WEBPACK FOOTER //
// Modus.vue?33c74218